/**
 * Single product page — gallery switcher, tabs, save button.
 * No ES module syntax — concatenated into one bundle by Gulp.
 */
function initProductPage() {
    initGallery();
    initTabs();
    initSaveButton();
    initSingleAddToCart();
}

function initGallery() {
    var galMain = document.getElementById('galMain');
    var thumbs  = document.querySelectorAll('.gal-thumb');
    if ( ! galMain || ! thumbs.length ) return;

    thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
            thumbs.forEach(function(t) { t.classList.remove('on'); });
            thumb.classList.add('on');
            galMain.style.backgroundImage = "url('" + thumb.dataset.src + "')";
        });
    });
}

function initTabs() {
    var heads = document.querySelectorAll('.tab-head');
    var panes = document.querySelectorAll('.tab-pane');
    if ( ! heads.length ) return;

    heads.forEach(function(head) {
        head.addEventListener('click', function() {
            heads.forEach(function(h) {
                h.classList.remove('on');
                h.setAttribute('aria-selected', 'false');
            });
            panes.forEach(function(p) { p.classList.remove('on'); });
            head.classList.add('on');
            head.setAttribute('aria-selected', 'true');
            var target = document.querySelector('.tab-pane[data-pane="' + head.dataset.tab + '"]');
            if ( target ) target.classList.add('on');
        });
    });
}

function initSaveButton() {
    var btn = document.getElementById('saveBtn');
    if ( ! btn ) return;
    btn.addEventListener('click', function() { btn.classList.toggle('on'); });
}

function initSingleAddToCart() {
    var form = document.querySelector('form.cart');
    if ( ! form || typeof reshoppitCart === 'undefined' ) return;

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        var btn = form.querySelector('.single_add_to_cart_button');
        if ( ! btn || btn.disabled || btn.classList.contains('disabled') ) return;

        // Product ID is on the button's value attribute (WooCommerce standard)
        var productId = btn.getAttribute('value') || '';
        if ( ! productId ) {
            var pidInput = form.querySelector('[name="product_id"]');
            productId = pidInput ? pidInput.value : '';
        }
        if ( ! productId ) { form.submit(); return; }

        var origText = btn.textContent.trim();
        btn.disabled = true;
        btn.classList.add('loading');

        var params = new URLSearchParams({
            action:     'woocommerce_ajax_add_to_cart',
            product_id: productId,
            quantity:   1,
            nonce:      reshoppitCart.nonce
        });

        fetch(reshoppitCart.ajaxUrl, {
            method:  'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body:    params.toString()
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
            btn.disabled = false;
            btn.classList.remove('loading');
            btn.textContent = origText;

            if ( typeof jQuery !== 'undefined' ) {
                var frags = (data && data.fragments) ? data.fragments : {};
                jQuery(document.body).trigger('added_to_cart', [frags, data.cart_hash || '']);
            }
        })
        .catch(function() {
            btn.disabled = false;
            btn.classList.remove('loading');
            btn.textContent = origText;
            form.submit(); // fallback: regular form submit
        });
    });
}
